import { EnvironmentVariables } from './environment-variables';

export const environment: EnvironmentVariables = {
  PIPELINE_STAGE: 'prod',
};
